const sortOrderDict = {
  "views-desc": "-youtube_view_count",
  "views-asc": "youtube_view_count",
  "title-asc": "title",
  "title-desc": "-title",
};

const pageSizeDefault = 10; // Defined in Django (DRF)!!!

export const returnQueryPath = (query) => {
  var _url = "https://api-py38.ukeability.org/v1/songs/";
  var params = [];

  if (query.tuning) {
    if (query.tuning != "all") {
      params.push("tuning=" + query.tuning);
    } else {
      // Note, the "all" isn't enabled anywhere yet. This is for future searching.
      console.log("Querying all tuning, omit the tuning param all together.");
    }
  } else {
    params.push("tuning=C");
  }

  if (query.onlyKnownChords) {
    var known_chords_encoded = encodeURIComponent(query.knownChords.join(","));
    params.push("user_chord_list=" + known_chords_encoded);
  }

  if (["tutorial", "playalong"].includes(query.content)) {
    params.push("content=" + query.content);
  }

  if (query.onlyFavoriteIds) {
    var favorites = encodeURIComponent(query.favoriteIds.join(","));
    params.push("favorites=" + favorites);
  }

  params.push("ordering=" + sortOrderDict[query.sortOrder]);

  if (query.searchQuery && query.searchQuery != "") {
    params.push("search=" + query.searchQuery);
  }

  if (query.pageSize != pageSizeDefault) {
    params.push("page_size=" + query.pageSize);
  }

  if (query.pageNumber > 1) {
    params.push("page=" + query.pageNumber);
  }

  if (params.length > 0) {
    _url = _url + "?" + params.join("&");
  }

  return _url;
};
